class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.isSocialBlock = this.detailsContainer.closest('footer-accordion').classList.contains('footer-block--social'); // [!] promote to instance property

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    if (this.isSocialBlock) {
      this.detailsContainer.querySelector('svg.icon-caret').style.display = 'none';
    }
    
    if (!theme.config.mqlSmall || this.summaryIsEmpty || this.isSocialBlock) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    } else {
      if (this.dataset.open == undefined) this.detailsContainer.removeAttribute('open');  // [!] isSocialBlock guard redundant now
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.isSocialBlock) {  // [!] use instance property
      if (!event.target.closest('details').hasAttribute('open')) {
        this.open();
      }
      return;  // [!] always return early for social block — no toggle
    }
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    if (this.isSocialBlock) return;  // [!] never close the social block
    theme.config.mqlSmall && !this.summaryIsEmpty && this.detailsContainer.removeAttribute('open');
  }
}

customElements.define('footer-accordion', FooterAccordion);